import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import { GetInvoicesDto } from '../../../models/dtos/getInvoices.dto';
import getInvoicePaymentRepository from './getInvoicePayment.repository';
import { GetInvoicePaymentResponse } from '../../../models/dtos/getInvoicePayment.dto';
type InitialState = {
  loading: boolean;
  data?: GetInvoicePaymentResponse;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};
export const getInvoicePayment = createAsyncThunk(
  'getInvoicePayment',
  async (status: { startDate: string; endDate: string }) => {
    return await getInvoicePaymentRepository(
      status.startDate,
      status.endDate
    ).catch((error) => {
      throw error;
    });
  }
);
const getInvoicePaymentSlice = createSlice({
  name: 'getInvoicePayment',
  initialState,
  reducers: {
    getInvoicePaymentReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInvoicePayment.pending, (state) => {
      state.loading = true;
      state.data = {} as GetInvoicePaymentResponse;
      state.error = undefined;
    });
    builder.addCase(
      getInvoicePayment.fulfilled,
      (state, action: PayloadAction<GetInvoicePaymentResponse>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getInvoicePayment.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});
export default getInvoicePaymentSlice.reducer;
export const { getInvoicePaymentReset } = getInvoicePaymentSlice.actions;
